import { occupationType, visaType } from 'apis/handler/auth/authSchema';
import { furnitureType, roomType } from 'apis/handler/listing/listingSchema';
import { COUNTRY_CODE_OPTIONS } from 'shared/constants';

import stationData from './subway.json';
import { removeWhitespace } from './utility';

/**
 *
 * @param occupation 유저가 보는 occupation
 * @returns 서버에 보내는 occupation
 */
export const convertOccupationToRequest = (occupation: string): occupationType => {
  switch (occupation) {
    case 'Undergraduate Student':
      return 'UNDERGRADUATE';
    case 'Graduate Student':
      return 'GRADUATE';
    case 'Exchange Student':
      return 'EXCHANGE';
    case 'Education/Academic Research':
      return 'EDUCATION';
    case 'IT/Software/Engineering':
      return 'IT_SOFTWARE_ENGINEERING';
    case 'Manufacture/Agriculture':
      return 'MANUFACTURE_AGRICULTURE';
    case 'Arts/Design':
      return 'ARTS_DESIGN';
    case 'Finance/Banking':
      return 'FINANCE_BANKING';
    case 'Public Service/Government':
      return 'PUBLIC_SERVICE';
    case 'Healthcare/Medical Service':
      return 'HEALTHCARE_MEDICAL';
    case 'Business/Sales':
      return 'BUSINESS_SALES';
    case 'Legal/Consulting':
      return 'LEGAL_CONSULTING';
    case 'Others':
      return 'OTHERS';
    default:
      return 'OTHERS';
  }
};

/**
 *
 * @param occupation 서버에서 받는 occupation
 * @returns 유저가 보는 occupation
 */
export const convertRequestToOccupation = (occupationType: string): string => {
  switch (occupationType) {
    case 'UNDERGRADUATE':
      return 'Undergraduate Student';
    case 'GRADUATE':
      return 'Graduate Student';
    case 'EXCHANGE':
      return 'Exchange Student';
    case 'EDUCATION':
      return 'Education/Academic Research';
    case 'IT_SOFTWARE_ENGINEERING':
      return 'IT/Software/Engineering';
    case 'MANUFACTURE_AGRICULTURE':
      return 'Manufacture/Agriculture';
    case 'ARTS_DESIGN':
      return 'Arts/Design';
    case 'FINANCE_BANKING':
      return 'Finance/Banking';
    case 'PUBLIC_SERVICE':
      return 'Public Service/Government';
    case 'HEALTHCARE_MEDICAL':
      return 'Healthcare/Medical Service';
    case 'BUSINESS_SALES':
      return 'Business/Sales';
    case 'LEGAL_CONSULTING':
      return 'Legal/Consulting';
    case 'OTHERS':
      return 'Others';
    default:
      return 'null';
  }
};

/**
 *
 * @param visaInfo 유저가 보는 visaInfo
 * @returns 서버에 보내는 visaInfo
 */
export const convertVisaInfoToRequest = (visaInfo: string): visaType => {
  switch (visaInfo) {
    case 'Diplomatic/Official(A-1,A-2)':
      return 'DIPLOMATIC_OFFICIAL';
    case 'Visa Exempted(B)':
      return 'VISA_EXEMPTED';
    case 'Journalism/Religious Affairs(C-1, D-5, D-6)':
      return 'JOURNALISM';
    case 'Short Term Visit(C-2, C-3)':
      return 'SHORT_TEM_VISIT';
    case 'Study(D-2)':
      return 'STUDY';
    case 'Trainee(D-3,D-4)':
      return 'TRAINEE';
    case 'Intra-Company Transfer(D-7)':
      return 'INTRA_COMPANY_TRANSFER';
    case 'Professional(C-4, D-1, D-8, D-9, D-10, E-1, E-2, E-3, E-4, E-5, E-6, E-7)':
      return 'PROFESSIONAL';
    case 'Non-Professional(E-8, E-9, E-10)':
      return 'NON_PROFESSIONAL';
    case 'Working Holiday(H-1)':
      return 'WORKING_HOLIDAY';
    case 'Work and Visit(H-2)':
      return 'WORK_VISIT';
    case 'Familiy Visitor/Dependent Family(F-1, F-2, F-3)':
      return 'FAMILY_VISITOR';
    case 'Overseas Korean(F-4)':
      return 'OVERSEA_KOREAN';
    case 'Permanent Residence(F-5)':
      return 'PERMANENT_RESIDENCE';
    case 'Marrige Migrant(F-6)':
      return 'MARRIAGE_MIGRANT';
    case 'Others(G-1)':
      return 'OTHERS';
    default:
      return 'OTHERS';
  }
};

/**
 *
 * @param visaType 서버에서 받는 visaType
 * @returns 유저가 보는 visaType
 */
export const convertRequestToVisaInfo = (visaType: string): string => {
  switch (visaType) {
    case 'DIPLOMATIC_OFFICIAL':
      return 'Diplomatic/Official(A-1,A-2)';
    case 'VISA_EXEMPTED':
      return 'Visa Exempted(B)';
    case 'JOURNALISM':
      return 'Journalism/Religious Affairs(C-1, D-5, D-6)';
    case 'SHORT_TEM_VISIT':
      return 'Short Term Visit(C-2, C-3)';
    case 'STUDY':
      return 'Study(D-2)';
    case 'TRAINEE':
      return 'Trainee(D-3,D-4)';
    case 'INTRA_COMPANY_TRANSFER':
      return 'Intra-Company Transfer(D-7)';
    case 'PROFESSIONAL':
      return 'Professional(C-4, D-1, D-8, D-9, D-10, E-1, E-2, E-3, E-4, E-5, E-6, E-7)';
    case 'NON_PROFESSIONAL':
      return 'Non-Professional(E-8, E-9, E-10)';
    case 'WORKING_HOLIDAY':
      return 'Working Holiday(H-1)';
    case 'WORK_VISIT':
      return 'Work and Visit(H-2)';
    case 'FAMILY_VISITOR':
      return 'Familiy Visitor/Dependent Family(F-1, F-2, F-3)';
    case 'OVERSEA_KOREAN':
      return 'Overseas Korean(F-4)';
    case 'PERMANENT_RESIDENCE':
      return 'Permanent Residence(F-5)';
    case 'MARRIAGE_MIGRANT':
      return 'Marrige Migrant(F-6)';
    case 'OTHERS':
      return 'Others(G-1)';
    default:
      return 'null';
  }
};

/**
 *
 * @param whereType 서버에서 받는 whereType
 * @returns 유저가 보는 whereType
 */
export const convertRequestToWhereType = (whereType: string): string | undefined => {
  switch (whereType) {
    case 'UNIVERSITY':
      return 'University';
    case 'ADDRESS':
      return 'Address';
    case 'STATION':
      return 'Station';
    default:
      return undefined;
  }
};

export const convertRoomTypeToRequest = (roomType: string): roomType => {
  switch (roomType) {
    case 'Studio':
      return 'STUDIO';
    case 'Sharehouse':
      return 'SHAREHOUSE';
    case 'Officetel':
      return 'OFFICETEL';
    case 'Others':
      return 'OTHERS';
    default:
      return 'OTHERS';
  }
};

export const convertRequestToRoomType = (roomType: string): string => {
  switch (roomType) {
    case 'STUDIO':
      return 'Studio';
    case 'SHAREHOUSE':
      return 'Sharehouse';
    case 'OFFICETEL':
      return 'Officetel';
    case 'OTHERS':
      return 'Others';
    default:
      return 'null';
  }
};

export const convertRequestToFurnitureType = (furnitureType: furnitureType): string => {
  switch (furnitureType) {
    case 'GAS_STOVE':
      return 'Gas Stove';
    case 'INDUCTION':
      return 'Induction';
    case 'REFRIGERATOR':
      return 'Refrigerator';
    case 'WASHING_MACHINE':
      return 'Washing Machine';
    case 'MICROWAVE_OVEN':
      return 'Microwave Oven';
    case 'AIR_CONDITIONING':
      return 'Air Conditioning';
    case 'DRYER':
      return 'Dryer';
    case 'TABLE':
      return 'Table';
    case 'TV':
      return 'TV';
    case 'WIFI':
      return 'Wifi';
    case 'WARDROBE':
      return 'Wardrobe';
    case 'SHELF':
      return 'Shelf';
    case 'DRAWER':
      return 'Drawer';
    case 'SHOE_RACK':
      return 'Shoe Rack';
    case 'BED':
      return 'Bed';
    default:
      return 'null';
  }
};

export const convertRequestToMonth = (month: string): string => {
  switch (month) {
    case '01':
      return 'JAN';
    case '02':
      return 'FEB';
    case '03':
      return 'MAR';
    case '04':
      return 'APR';
    case '05':
      return 'MAY';
    case '06':
      return 'JUN';
    case '07':
      return 'JUL';
    case '08':
      return 'AUG';
    case '09':
      return 'SEP';
    case '10':
      return 'OCT';
    case '11':
      return 'NOV';
    case '12':
      return 'DEC';
    default:
      return 'null';
  }
};

export const convertMonthToRequest = (month: string): string => {
  switch (month) {
    case 'JAN':
      return '01';
    case 'FEB':
      return '02';
    case 'MAR':
      return '03';
    case 'APR':
      return '04';
    case 'MAY':
      return '05';
    case 'JUN':
      return '06';
    case 'JUL':
      return '07';
    case 'AUG':
      return '08';
    case 'SEP':
      return '09';
    case 'OCT':
      return '10';
    case 'NOV':
      return '11';
    case 'DEC':
      return '12';
    default:
      return 'null';
  }
};

export const convertNumToCountryCode = (num: string): string => {
  return COUNTRY_CODE_OPTIONS.find((option) => removeWhitespace(option, 'NUM') === num) || '';
};

export const convertRequestToContractStatusType = (contractStatusType: string): string => {
  switch (contractStatusType) {
    case 'AWAITING':
      return 'Awaiting Confirmation';
    case 'CONFIRMED':
      return 'Confirmed';
    case 'WITHDRAWN':
      return 'Withdrawn';
    case 'REJECTED':
      return 'Rejected';
    default:
      return 'null';
  }
};

export const convertRequestToOrderStatusType = (orderStatusType: string): string => {
  switch (orderStatusType) {
    case 'PROCESSING':
      return 'Processing';
    case 'COMPLETED':
      return 'Completed';
    case 'CANCELED':
      return 'Canceled';
    default:
      return 'null';
  }
};

export const convertRequestToPaymentType = (paymentType: string): string => {
  switch (paymentType) {
    case 'MONTHLY':
      return 'Monthly Payment';
    case 'LUMP_SUM':
      return 'Lump-sum Payment';
    default:
      return '-';
  }
};

export const convertRequestToFacilityType = (facilityType: string): string => {
  switch (facilityType) {
    case 'ELEVATOR':
      return 'Elevator';
    case 'CCTV':
      return 'CCTV';
    case 'ENTRY_DOORLOCK':
      return 'Entry Doorlock';
    default:
      return '-';
  }
};

export const convertRequestToRentExcludesType = (rentExcludesType: string): string => {
  switch (rentExcludesType) {
    case 'ELECTRICITY':
      return 'Electricity';
    case 'GAS':
      return 'Gas';
    case 'WATER':
      return 'Water';
    case 'INTERNET':
      return 'Internet';
    default:
      return '-';
  }
};

export const convertRentExcludesList = (rentExcludesList: string[]): string => {
  if (rentExcludesList.length === 0) {
    return '-';
  }

  return rentExcludesList.map((rentExcludes) => convertRequestToRentExcludesType(rentExcludes)).join(', ');
};

export const convertRequestToCommentType = (commentType: string): string => {
  switch (commentType) {
    case 'COMMENT1':
      return 'Only women can move in.';
    case 'COMMENT2':
      return 'It is close to the subway station.';
    case 'COMMENT3':
      return "It's close to the university shuttle bus stop.";
    case 'COMMENT4':
      return 'It has good view.';
    case 'COMMENT5':
      return 'It has good natural lighting.';
    case 'COMMENT6':
      return 'The landlord takes good care of it.';
    case 'COMMENT7':
      return "There are parks and trails nearby, so it's great for a walk.";
    case 'COMMENT8':
      return "It's a newly built building.";
    case 'COMMENT9':
      return 'The cleaning may not be perfect, cleaning before moving in is recommended.';
    case 'COMMENT10':
      return "It's a semi-basement unit, but from the outside, it appears to be on the first floor.";
    default:
      return '-';
  }
};

export const convertSubwayStationKorToEng = (subway: string): string => {
  if (stationData.hasOwnProperty(subway)) {
    return stationData[subway as keyof typeof stationData];
  }

  return subway;
};

export const convertSubwayStationEngToKor = (subway: string): string => {
  const station = Object.entries(stationData).find(([, value]) => value === subway);

  return station ? station[0] : subway;
};

export const convertRequestToHeatingType = (heatingType: string): string => {
  switch (heatingType) {
    case 'INDIVIDUAL':
      return 'Individual heating';
    case 'CENTRAL':
      return 'Central heating';
    default:
      return '-';
  }
};

export const convertRequestToBuildingFrontType = (buildingFrontType: string): string => {
  switch (buildingFrontType) {
    case 'EXIST':
      return 'Yes';
    case 'NOT_EXIST':
      return 'No';
    case 'UNKNOWN':
      return 'Unable to confirm';
    default:
      return '-';
  }
};

export const convertRequestToWindowDirectionType = (windowDirectionType: string): string => {
  switch (windowDirectionType) {
    case 'NORTH':
      return 'North';
    case 'NORTHEAST':
      return 'Northeast';
    case 'EAST':
      return 'East';
    case 'SOUTHEAST':
      return 'Southeast';
    case 'SOUTH':
      return 'South';
    case 'SOUTHWEST':
      return 'Southwest';
    case 'WEST':
      return 'West';
    case 'NORTHWEST':
      return 'Northwest';
    case 'UNABLE':
      return 'Unable to confirm';
    default:
      return '-';
  }
};

export const convertRequestToLanguage = (language: string): string => {
  switch (language) {
    case 'ENGLISH':
      return 'English';
    case 'KOREAN':
      return 'Korean';
    case 'CHINESE':
      return 'Chinese';
    case 'JAPANESE':
      return 'Japanese';
    case 'VIETNAMESE':
      return 'Vietnamese';
    default:
      return '-';
  }
};

export const convertRequestToUniversity = (univ: string): string => {
  switch (univ) {
    case 'SNU':
      return 'Seoul National University';
    case 'SSU':
      return 'Soongsil University';
    case 'CAU':
      return 'Chung-Ang University';
    case 'SKKU':
      return 'Sungkyunkwan University';
    case 'KOREA':
      return 'Korea University';
    case 'DONGGUK':
      return 'Dongguk University';
    case 'EWHA':
      return 'Ewha University';
    case 'KHU':
      return 'Kyung Hee University';
    case 'HUFS':
      return 'Hankuk University of Foreign Studies';
    default:
      return '-';
  }
};

export const convertRequestToUniversityKorean = (univ: string): string => {
  switch (univ) {
    case 'SNU':
      return '서울대학교';
    case 'SSU':
      return '숭실대학교';
    case 'CAU':
      return '중앙대학교';
    case 'SKKU':
      return '성균관대학교';
    case 'KOREA':
      return '고려대학교';
    case 'DONGGUK':
      return '동국대학교';
    case 'EWHA':
      return '이화여자대학교';
    case 'KHU':
      return '경희대학교';
    case 'HUFS':
      return '한국외국어대학교';
    default:
      return '-';
  }
};

export const convertNationalityToShortCode = (nationality: string): string => {
  switch (nationality) {
    case 'Korea (+82)':
      return 'KR';
    case 'Vietnam (+84)':
      return 'VN';
    case 'China (+86)':
      return 'CN';
    case 'USA, Canada (+1)':
      return 'US';
    case 'Germany (+49)':
      return 'DE';
    case 'Afghanistan (+93)':
      return 'AF';
    case 'Albania (+355)':
      return 'AL';
    case 'Algeria (+213)':
      return 'DZ';
    case 'American Samoa (+1)':
      return 'AS';
    case 'Andorra (+376)':
      return 'AD';
    case 'Angola (+244)':
      return 'AO';
    case 'Anguilla (+1)':
      return 'AI';
    case 'Antigua and Barbuda (+1)':
      return 'AG';
    case 'Argentina (+54)':
      return 'AR';
    case 'Armenia (+374)':
      return 'AM';
    case 'Australia (+61)':
      return 'AU';
    case 'Austria (+43)':
      return 'AT';
    case 'Azerbaijan (+994)':
      return 'AZ';
    case 'Bahamas (+1)':
      return 'BS';
    case 'Bahrain (+973)':
      return 'BH';
    case 'Bangladesh (+880)':
      return 'BD';
    case 'Barbados (+1)':
      return 'BB';
    case 'Belarus (+375)':
      return 'BY';
    case 'Belgium (+32)':
      return 'BE';
    case 'Belize (+501)':
      return 'BZ';
    case 'Benin (+229)':
      return 'BJ';
    case 'Bermuda (+1)':
      return 'BM';
    case 'Bhutan (+975)':
      return 'BT';
    case 'Bolivia (+591)':
      return 'BO';
    case 'Bosnia and Herzegovina (+387)':
      return 'BA';
    case 'Botswana (+267)':
      return 'BW';
    case 'Brazil (+55)':
      return 'BR';
    case 'Brunei (+673)':
      return 'BN';
    case 'Bulgaria (+359)':
      return 'BG';
    case 'Burkina Faso (+226)':
      return 'BF';
    case 'Burundi (+257)':
      return 'BI';
    case 'Cambodia (+855)':
      return 'KH';
    case 'Cameroon (+237)':
      return 'CM';
    case 'Canada (+1)':
      return 'CA';
    case 'Cape Verde (+238)':
      return 'CV';
    case 'Cayman Islands (+1)':
      return 'KY';
    case 'Central African Republic (+236)':
      return 'CF';
    case 'Chad (+235)':
      return 'TD';
    case 'Chile (+56)':
      return 'CL';
    case 'Colombia (+57)':
      return 'CO';
    case 'Comoros (+269)':
      return 'KM';
    case 'Congo (+242)':
      return 'CG';
    case 'Congo, Democratic Republic (+243)':
      return 'CD';
    case 'Costa Rica (+506)':
      return 'CR';
    case 'Croatia (+385)':
      return 'HR';
    case 'Cuba (+53)':
      return 'CU';
    case 'Cyprus (+357)':
      return 'CY';
    case 'Czech Republic (+420)':
      return 'CZ';
    case 'Denmark (+45)':
      return 'DK';
    case 'Djibouti (+253)':
      return 'DJ';
    case 'Dominica (+1)':
      return 'DM';
    case 'Dominican Republic (+1)':
      return 'DO';
    case 'Ecuador (+593)':
      return 'EC';
    case 'Egypt (+20)':
      return 'EG';
    case 'El Salvador (+503)':
      return 'SV';
    case 'Equatorial Guinea (+240)':
      return 'GQ';
    case 'Eritrea (+291)':
      return 'ER';
    case 'Estonia (+372)':
      return 'EE';
    case 'Ethiopia (+251)':
      return 'ET';
    case 'Fiji (+679)':
      return 'FJ';
    case 'Finland (+358)':
      return 'FI';
    case 'France (+33)':
      return 'FR';
    case 'French Guiana (+594)':
      return 'GF';
    case 'Gabon (+241)':
      return 'GA';
    case 'Gambia (+220)':
      return 'GM';
    case 'Georgia (+995)':
      return 'GE';
    case 'Ghana (+233)':
      return 'GH';
    case 'Greece (+30)':
      return 'GR';
    case 'Greenland (+299)':
      return 'GL';
    case 'Grenada (+1)':
      return 'GD';
    case 'Guatemala (+502)':
      return 'GT';
    case 'Guinea (+224)':
      return 'GN';
    case 'Guinea-Bissau (+245)':
      return 'GW';
    case 'Guyana (+592)':
      return 'GY';
    case 'Haiti (+509)':
      return 'HT';
    case 'Honduras (+504)':
      return 'HN';
    case 'Hong Kong (+852)':
      return 'HK';
    case 'Hungary (+36)':
      return 'HU';
    case 'Iceland (+354)':
      return 'IS';
    case 'India (+91)':
      return 'IN';
    case 'Indonesia (+62)':
      return 'ID';
    case 'Iran (+98)':
      return 'IR';
    case 'Iraq (+964)':
      return 'IQ';
    case 'Ireland (+353)':
      return 'IE';
    case 'Israel (+972)':
      return 'IL';
    case 'Italy (+39)':
      return 'IT';
    case 'Jamaica (+1)':
      return 'JM';
    case 'Japan (+81)':
      return 'JP';
    case 'Jordan (+962)':
      return 'JO';
    case 'Kazakhstan (+7)':
      return 'KZ';
    case 'Kenya (+254)':
      return 'KE';
    case 'Kiribati (+686)':
      return 'KI';
    case 'Kuwait (+965)':
      return 'KW';
    case 'Kyrgyzstan (+996)':
      return 'KG';
    case 'Laos (+856)':
      return 'LA';
    case 'Latvia (+371)':
      return 'LV';
    case 'Lebanon (+961)':
      return 'LB';
    case 'Lesotho (+266)':
      return 'LS';
    case 'Liberia (+231)':
      return 'LR';
    case 'Libya (+218)':
      return 'LY';
    case 'Liechtenstein (+423)':
      return 'LI';
    case 'Lithuania (+370)':
      return 'LT';
    case 'Luxembourg (+352)':
      return 'LU';
    case 'Macao (+853)':
      return 'MO';
    case 'Macedonia (+389)':
      return 'MK';
    case 'Madagascar (+261)':
      return 'MG';
    case 'Malawi (+265)':
      return 'MW';
    case 'Malaysia (+60)':
      return 'MY';
    case 'Maldives (+960)':
      return 'MV';
    case 'Mali (+223)':
      return 'ML';
    case 'Malta (+356)':
      return 'MT';
    case 'Marshall Islands (+692)':
      return 'MH';
    case 'Mauritania (+222)':
      return 'MR';
    case 'Mauritius (+230)':
      return 'MU';
    case 'Mexico (+52)':
      return 'MX';
    case 'Micronesia (+691)':
      return 'FM';
    case 'Moldova (+373)':
      return 'MD';
    case 'Monaco (+377)':
      return 'MC';
    case 'Mongolia (+976)':
      return 'MN';
    case 'Montenegro (+382)':
      return 'ME';
    case 'Morocco (+212)':
      return 'MA';
    case 'Mozambique (+258)':
      return 'MZ';
    case 'Myanmar (+95)':
      return 'MM';
    case 'Namibia (+264)':
      return 'NA';
    case 'Nauru (+674)':
      return 'NR';
    case 'Nepal (+977)':
      return 'NP';
    case 'Netherlands (+31)':
      return 'NL';
    case 'New Zealand (+64)':
      return 'NZ';
    case 'Nicaragua (+505)':
      return 'NI';
    case 'Niger (+227)':
      return 'NE';
    case 'Nigeria (+234)':
      return 'NG';
    case 'North Korea (+850)':
      return 'KP';
    case 'Norway (+47)':
      return 'NO';
    case 'Oman (+968)':
      return 'OM';
    case 'Pakistan (+92)':
      return 'PK';
    case 'Palau (+680)':
      return 'PW';
    case 'Palestine (+970)':
      return 'PS';
    case 'Panama (+507)':
      return 'PA';
    case 'Papua New Guinea (+675)':
      return 'PG';
    case 'Paraguay (+595)':
      return 'PY';
    case 'Peru (+51)':
      return 'PE';
    case 'Philippines (+63)':
      return 'PH';
    case 'Poland (+48)':
      return 'PL';
    case 'Portugal (+351)':
      return 'PT';
    case 'Qatar (+974)':
      return 'QA';
    case 'Romania (+40)':
      return 'RO';
    case 'Russia (+7)':
      return 'RU';
    case 'Rwanda (+250)':
      return 'RW';
    case 'Saint Kitts and Nevis (+1)':
      return 'KN';
    case 'Saint Lucia (+1)':
      return 'LC';
    case 'Saint Vincent and the Grenadines (+1)':
      return 'VC';
    case 'Samoa (+685)':
      return 'WS';
    case 'San Marino (+378)':
      return 'SM';
    case 'Sao Tome and Principe (+239)':
      return 'ST';
    case 'Saudi Arabia (+966)':
      return 'SA';
    case 'Senegal (+221)':
      return 'SN';
    case 'Serbia (+381)':
      return 'RS';
    case 'Seychelles (+248)':
      return 'SC';
    case 'Sierra Leone (+232)':
      return 'SL';
    case 'Singapore (+65)':
      return 'SG';
    case 'Slovakia (+421)':
      return 'SK';
    case 'Slovenia (+386)':
      return 'SI';
    case 'Solomon Islands (+677)':
      return 'SB';
    case 'Somalia (+252)':
      return 'SO';
    case 'South Africa (+27)':
      return 'ZA';
    case 'South Sudan (+211)':
      return 'SS';
    case 'Spain (+34)':
      return 'ES';
    case 'Sri Lanka (+94)':
      return 'LK';
    case 'Sudan (+249)':
      return 'SD';
    case 'Suriname (+597)':
      return 'SR';
    case 'Swaziland (+268)':
      return 'SZ';
    case 'Sweden (+46)':
      return 'SE';
    case 'Switzerland (+41)':
      return 'CH';
    case 'Syria (+963)':
      return 'SY';
    case 'Taiwan (+886)':
      return 'TW';
    case 'Tajikistan (+992)':
      return 'TJ';
    case 'Tanzania (+255)':
      return 'TZ';
    case 'Thailand (+66)':
      return 'TH';
    case 'Timor-Leste (+670)':
      return 'TL';
    case 'Togo (+228)':
      return 'TG';
    case 'Tonga (+676)':
      return 'TO';
    case 'Trinidad and Tobago (+1)':
      return 'TT';
    case 'Tunisia (+216)':
      return 'TN';
    case 'Turkey (+90)':
      return 'TR';
    case 'Turkmenistan (+993)':
      return 'TM';
    case 'Tuvalu (+688)':
      return 'TV';
    case 'Uganda (+256)':
      return 'UG';
    case 'Ukraine (+380)':
      return 'UA';
    case 'United Arab Emirates (+971)':
      return 'AE';
    case 'United Kingdom (+44)':
      return 'GB';
    case 'Uruguay (+598)':
      return 'UY';
    case 'Uzbekistan (+998)':
      return 'UZ';
    case 'Vanuatu (+678)':
      return 'VU';
    case 'Venezuela (+58)':
      return 'VE';
    case 'Yemen (+967)':
      return 'YE';
    case 'Zambia (+260)':
      return 'ZM';
    case 'Zimbabwe (+263)':
      return 'ZW';
    default:
      return '';
  }
};
